module.exports = __webpack_public_path__ + "static/media/sport-shoes.26f23ea8.webp";